/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PriceHistogramFilter
 */
export interface PriceHistogramFilter {
    /**
     * 
     * @type {number}
     * @memberof PriceHistogramFilter
     */
    min: number;
    /**
     * 
     * @type {number}
     * @memberof PriceHistogramFilter
     */
    max: number;
    /**
     * 
     * @type {string}
     * @memberof PriceHistogramFilter
     */
    currency: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PriceHistogramFilter
     */
    data: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof PriceHistogramFilter
     */
    average: number;
}

/**
 * Check if a given object implements the PriceHistogramFilter interface.
 */
export function instanceOfPriceHistogramFilter(value: object): value is PriceHistogramFilter {
    if (!('min' in value) || value['min'] === undefined) return false;
    if (!('max' in value) || value['max'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('average' in value) || value['average'] === undefined) return false;
    return true;
}

export function PriceHistogramFilterFromJSON(json: any): PriceHistogramFilter {
    return PriceHistogramFilterFromJSONTyped(json, false);
}

export function PriceHistogramFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceHistogramFilter {
    if (json == null) {
        return json;
    }
    return {
        
        'min': json['min'],
        'max': json['max'],
        'currency': json['currency'],
        'data': json['data'],
        'average': json['average'],
    };
}

export function PriceHistogramFilterToJSON(value?: PriceHistogramFilter | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'min': value['min'],
        'max': value['max'],
        'currency': value['currency'],
        'data': value['data'],
        'average': value['average'],
    };
}

